import React from "react";
import Main from "./main";
import Header from "../../Common/header";
import Footer from "../../Common/footer";
import useDocumentTitle from "../../Common/useDocumentTitle";

/**
 * Returns the Home page component.
 * 
 * @returns The Home page component.
 */
const Home = () => {
  useDocumentTitle("Home");

  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
};

export default Home;